import { adaptLoadedResources } from './adaptLoadedResources';
import { I18nResource } from './locales.types';

export const resources: I18nResource = adaptLoadedResources();
